var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommercialGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cjentu3tha"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 534",
    width: 24,
    height: 24,
    rx: 8,
    transform: "translate(20622 7460)",
    style: {
      stroke: "#707070",
      fill: "#de4d65"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 434",
    transform: "translate(-752 -439)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 120",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(752 439)",
    style: {
      fill: "#eea5b1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 121",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(754 441)",
    style: {
      fill: "#de4d65"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 433"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 163",
    transform: "translate(-19865 -7017)",
    style: {
      clipPath: "url(#cjentu3tha)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 533",
    style: {
      fill: "#fff",
      stroke: "#707070"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h21v24H0z",
    transform: "translate(20624 7460)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h20v23H.5z",
    transform: "translate(20624 7460)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 464",
    d: "M25.85 0H0v25.85h25.85zm-21 22.618a.539.539 0 1 0 0 1.077H21a.539.539 0 0 0 0-1.077h-.539v-9.155a.539.539 0 0 0-.539-.539h-2.15V5.385L9.155 2.154v8.617H8.078V7H7v3.77H5.924a.539.539 0 0 0-.539.539v11.309zm1.612-10.77v10.77h2.693v-10.77zm12.925 10.77H18.31v-1.077h-1.615v1.077h-1.078V14h3.77zM11.848 7h-1.077v1.078h1.077zm1.077 0H14v1.078h-1.075zm3.231 0h-1.077v1.078h1.077zm-5.385 2.155h1.077v1.077h-1.077zm3.231 0h-1.077v1.077H14zm1.077 0h1.077v1.077h-1.077zm-3.231 2.154h-1.077v1.077h1.077zm1.077 0H14v1.077h-1.075zm3.231 0h-1.077v1.077h1.077zm-5.385 2.154h1.077v1.077h-1.077zm3.231 0h-1.077v1.077H14zm-2.154 2.154h-1.077v1.077h1.077zm1.077 0H14v1.077h-1.075zm-2.154 2.154h1.077v1.077h-1.077zm3.231 0h-1.077v1.077H14zm-2.154 2.154h-1.077V21h1.077zm1.077 0H14V21h-1.075zm3.77-3.77h1.615v-1.076h-1.615zm1.615 2.155h-1.615v-1.077h1.615zm-1.616 2.154h1.616v-1.077h-1.615z",
    transform: "translate(20621.145 7459.006)",
    style: {
      fillRule: "evenodd",
      fill: "#de4d65"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 535",
    width: 18,
    height: 0.6,
    rx: 0.3,
    transform: "translate(760 465.5)",
    style: {
      fill: "#080808"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommercialGraphic);
export default __webpack_public_path__ + "static/media/commercial-graphic.3af407ece6e8cb41f4da892cde2d5e45.svg";
export { ForwardRef as ReactComponent };